import React from "react";
import { Collapse } from "antd";

export const DatasetsSection = () => {
  const faq = [
    {
      q: "Ideathon'a katılmak için ücret ödemem gerekiyor mu?",
      a: "Hayır, yarışma katılımı tamamen ücretsizdir.",
    },
    {
      q: "Kimler başvuru yapabilir?",
      a: "Üniversitelerin ön lisans, lisans, yüksek lisans ve doktora seviyesindeki öğrencileri başvurabilir.",
    },
    {
      q: "Takım yapısı nasıl olmalı?",
      a: "Takımlar en az 2, en fazla 4 kişiden oluşmalıdır.",
    },
    {
      q: "Ideathon fiziksel mi yoksa çevrimiçi mi?",
      a: "Final günü etkinliği Konya'daki Kapsül Teknoloji Platformu Zindankale Yerleşkesi'nde yüz yüze yapılacaktır.",
    },
    {
      q: "Etkinlikte hazır veri seti sağlanacak mı?",
      a: "Hayır. Veriye dayalı model kurgulayan ekipler veri kaynaklarını kendileri araştırmalı ve entegre etmelidir.",
    },
    {
      q: "Her katılımcı birden fazla takımda olabilir mi?",
      a: "Hayır. Her katılımcı yalnızca tek bir takımda yarışmaya katılabilir.",
    },
    {
      q: "Sunum süresi ne kadar?",
      a: "Final gününde her takım için 5 dakika sunum ve 3 dakika soru-cevap süresi vardır.",
    },
  ];

  return (
    <section id="faq" className="px-4 sm:px-6 lg:px-10 py-14 sm:py-16 sm:mb-16 bg-[var(--bg-primary)]">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-4xl sm:text-5xl font-black text-[var(--text-primary)] mb-4">Sıkça Sorulan Sorular</h2>
          <div className="w-24 h-1 mx-auto rounded-full mb-6 bg-[#73E03A]" />
          <p className="text-[var(--text-secondary)]">Katılım süreciyle ilgili en çok merak edilen konular</p>
        </div>
        <div
          className="kapsul-card p-3 sm:p-5 border"
          style={{
            borderColor: "rgba(47,111,30,0.35)",
            background: "linear-gradient(160deg, rgba(242,252,235,0.96), rgba(233,247,223,0.9))",
          }}
        >
          <Collapse
            ghost
            items={faq.map((item, index) => ({
              key: String(index),
              label: <span className="font-semibold text-[var(--text-primary)]">{item.q}</span>,
              children: <p className="text-[var(--text-secondary)]">{item.a}</p>,
            }))}
          />
        </div>
      </div>
    </section>
  );
};